import { PropsWithChildren, useEffect } from 'react';
import { clsx } from 'clsx';
import { makeStyles } from '@mui/styles';
import { useLocation } from 'react-router-dom';

import { useSettingsContext } from '@providers';

interface Props {
  name: string;
  title?: string;
  className?: string;
  action?: {
    title: string;
    onClick: () => void;
  }
}

export const Sidepanel = ({
  name,
  title,
  className,
  action,
  children,
}: PropsWithChildren<Props>) => {
  const location = useLocation();
  const { panelName, setPanelName } = useSettingsContext();
  const cls = useStyles();
  const isActive = panelName === name;
  const close = () => setPanelName(null);

  useEffect(() => {
    panelName && setPanelName(null);
  }, [location.pathname]);

  return (
    <div className={clsx(cls.modal, className, isActive && cls.isActive)}>
      <div className={cls.modalWrap}>
        <div className={cls.modalContent}>
          <div className={cls.modalClose}>
            <div className={cls.modalCloseIcon} onClick={close}>
              <svg xmlns="http://www.w3.org/2000/svg"
                style={{ display: 'inline-block', marginTop: -10, marginRight: -40 }}
                width="35"
                height="35"
                viewBox="0 0 35 35"
                fill="none">
                <path d="M17.5039 0C7.83826 0 0 7.83826 0 17.5039C0 27.1695 7.83826 35.0078 17.5039 35.0078C27.1695 35.0078 35.0078 27.1695 35.0078 17.5039C34.9922 7.83826 27.1617 0.00777605 17.5039 0Z"
                  fill="#002A77" />
                <path d="M24.0903 10.9101C23.787 10.6068 23.2971 10.6068 22.9938 10.9101L17.5039 16.4L12.0141 10.9101C11.7108 10.6068 11.2209 10.6068 10.9176 10.9101C10.6144 11.2133 10.6144 11.7032 10.9176 12.0065L16.4075 17.4964L10.9176 22.9863C10.6144 23.2895 10.6144 23.7794 10.9176 24.0827C11.2209 24.386 11.7108 24.386 12.0141 24.0827L17.5039 18.5928L22.9938 24.0827C23.2971 24.386 23.787 24.386 24.0903 24.0827C24.3935 23.7794 24.3935 23.2895 24.0903 22.9863L18.6004 17.4964L24.0903 12.0065C24.3935 11.7032 24.3935 11.2133 24.0903 10.9101Z"
                  fill="#FFFFFF" />
              </svg>
            </div>
          </div>
          {action && (
            <button onClick={action.onClick} className={cls.action}>{action.title}</button>
          )}
          {title && <div className={cls.modalTitle}>{title}</div>}
          <div className={cls.modalChildren}>{children}</div>
        </div>
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  modal: {
    position: 'fixed',
    top: 60,
    right: 0,
    bottom: 0,
    transform: 'translateX(100%)',
    transition: 'all ease 0.2s',
    zIndex: 10,
    marginRight: '0 !important',
  },
  isActive: {
    transform: 'translateX(0)',
  },
  modalWrap: {
    minWidth: 620,
    background: '#FFFFFF',
    padding: '0 60px 200px',
    zIndex: 2,
    position: 'relative',
    height: '100vh',
    overflowY: 'auto',
    borderLeft: '2px solid #042E6B',
    borderTop: '1px solid #bbb',
  },
  modalContent: {
    position: 'relative',
    zIndex: 1,
    paddingTop: 10,
  },
  modalTitle: {
    color: '#000',
    fontFamily: 'var(--font-primary)',
    fontSize: 25,
    fontWeight: 500,
    textAlign: 'center',
  },
  modalClose: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  modalCloseIcon: {
    position: 'absolute',
    top: 24,
    right: -10,
    cursor: 'pointer',
  },
  modalChildren: {
    marginTop: 0,
  },
  action: {
    position: 'absolute',
    top: 12,
    left: 8,
    background: 'transparent',
    border: '1px solid #FD8A32',
    borderRadius: 8,
    color: '#FD8A32',
    padding: '5px 10px',
    fontSize: 15,
    fontWeight: 500,
    cursor: 'pointer',
  },
});
